import './trcButton.css';

const TRCRequestButton = ({ onClick, icon, children, variant = 'primary', iconPosition = 'left', disabled=false }) => {
	return (
		<button className={`trc-button trc-button--${variant}`} onClick={onClick} disabled={disabled}>
			{iconPosition === 'left' && icon && <span className="trc-button__icon">{icon}</span>}
			<span className="trc-button__label">{children}</span>
			{iconPosition === 'right' && icon && <span className="trc-button__icon">{icon}</span>}
		</button>
	);
};

export default TRCRequestButton;
